import { useCallback } from "react";

/**
 * A memoized Enter/Space keydown handler for a `role="button"` element -
 * needed wherever a row can't literally be a `<button>` because it contains
 * its own focusable descendant (HTML5 forbids nesting one inside the
 * other), so it falls to the element to reimplement the native button's
 * keyboard activation itself.
 */
export function useKeyboardActivation(
  onActivate: () => void
): (e: React.KeyboardEvent) => void {
  return useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onActivate();
      }
    },
    [onActivate]
  );
}
